import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_GET_CARPARKS_AUTOCOMPLETE,
  CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE,
  CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE,
  REINIT_STATE,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeCarpark } from '../../../models/cpm/carpark';
import { deserialize as deserializeCustomer } from '../../../models/cpm/customer';
import { deserialize as deserializeParking } from '../../../models/cpm/parking';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmAutoComplete;
const autoComplete = (state = initialSettings, action) => {
  let key;

  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      switch (action.target) {
        case 'autoCompleteCarparks':
          key = 'carparks';
          break;
        default:
          key = null;
          break;
      }

      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }

      return state;

    // CPM_GET_CARPARKS_AUTOCOMPLETE
    case CPM_GET_CARPARKS_AUTOCOMPLETE:
      return {
        ...state,
        carparks: {
          ...state.carparks,
          loading: true,
          error: null,
          elements: {
            ...state.carparks.elements,
            data: null,
          },
        },
      };

    case `${CPM_GET_CARPARKS_AUTOCOMPLETE}_ERROR`:
      return {
        ...state,
        carparks: {
          ...state.carparks,
          loading: false,
          error: action.error,
        },
      };

    case `${CPM_GET_CARPARKS_AUTOCOMPLETE}_SUCCESS`:
      return {
        ...state,
        carparks: {
          ...state.carparks,
          loading: false,
          elements: {
            ...state.carparks.elements,
            data: deserializeCarpark(action.data.listCarparks.entries),
            pageNumber: _parseInt(action.data.listCarparks.pageNumber),
            pageSize: _parseInt(action.data.listCarparks.pageSize),
            totalEntries: _parseInt(action.data.listCarparks.totalEntries),
            totalPages: _parseInt(action.data.listCarparks.totalPages),
          },
        },
      };

    // CARPARK CUSTOMERS
    case CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE:
      return {
        ...state,
        customers: {
          ...state.customers,
          elements: [],
          loading: true,
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE}_SUCCESS`:
      return {
        ...state,
        customers: {
          ...state.customers,
          elements: deserializeCustomer(action.data.listCustomers.entries),
          pagination: {
            pageNumber: _parseInt(action.data.listCustomers.pageNumber),
            totalPages: _parseInt(action.data.listCustomers.totalPages),
          },
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE}_ERROR`:
      return {
        ...state,
        customers: {
          ...state.customers,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    // CARPARK PARKINGS
    case CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE:
      return {
        ...state,
        parkings: {
          ...state.parkings,
          elements: [],
          loading: true,
        },
      };
    case `${CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE}_SUCCESS`:
      return {
        ...state,
        parkings: {
          ...state.parkings,
          elements: deserializeParking(action.data.listParkings.entries),
          pagination: {
            pageNumber: _parseInt(action.data.listParkings.pageNumber),
            totalPages: _parseInt(action.data.listParkings.totalPages),
          },
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE}_ERROR`:
      return {
        ...state,
        parkings: {
          ...state.parkings,
          elements: [],
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default autoComplete;



// WEBPACK FOOTER //
// ./reducers/cpm/autoComplete/autoComplete.js